// 9fbef606107a605d69c0edbcd8029e5d

export const GLOBAL_MODULES_LABELS = 'global.modules';

export const lblModuleGAddToBag = `lbl_moduleG_add_to_bag`;
export const lblSelectSize = `lbl_select_size`;
export const lblDone = `lbl_done`;
export const lblSize = 'lbl_size';
export const lblOff = `lbl_off`;

export const GlobalModulesLabels = {
  global: {
    modules: {
      [lblModuleGAddToBag]: 'Add To Bag',
      [lblSelectSize]: 'Select size',
      [lblSize]: 'Size',
      [lblDone]: 'Done',
      [lblOff]: 'OFF',
      lbl_bundle_summary: 'Bundle Summary',
      lbl_add: 'Add',
    },
  },
};
